export enum DialerNoConsentMode {
  DIAL_ALONE = "DIAL_ALONE",
  SKIP = "SKIP",
}
